import {globalConfig} from 'Config/config';
import {agentTokenRefresh} from 'Redux/Slices/login';

let handleRefreshInterval;

export const startTokenRefreshTimer = (loginInfo, store, navigate) => {
  // Clear any interval already running (e.g. from a previous call after the
  // token itself was refreshed) so we never accumulate multiple concurrent timers.
  stopTokenRefreshTimer();

  const bufferTimer = 3 * 60;
  const delay = (loginInfo?.expires_in - bufferTimer) * 1000;
  // A missing/invalid expires_in would coerce setInterval's delay to 0 (fires
  // immediately, repeatedly) — bail out instead of scheduling a runaway loop.
  if (!Number.isFinite(delay) || delay <= 0) return;

  handleRefreshInterval = setInterval(async () => {
    try {
      let response = await store.dispatch(agentTokenRefresh()).unwrap();
      if (response.error || response.errors) {
        stopTokenRefreshTimer();
        sessionStorage.clear();
        localStorage.clear();
        window.location.replace(
          `${globalConfig._config.internalSSOConfig.REACT_APP_KEYCLOAK_ENDPOINT}/realms/${globalConfig._config.internalSSOConfig.REACT_APP_REALM}/protocol/openid-connect/logout?redirect_uri=${window.location.href}`,
        );
      }
    } catch (error) {
      stopTokenRefreshTimer();
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace(
        `${globalConfig._config.internalSSOConfig.REACT_APP_KEYCLOAK_ENDPOINT}/realms/${globalConfig._config.internalSSOConfig.REACT_APP_REALM}/protocol/openid-connect/logout?redirect_uri=${window.location.href}`,
      );
    }
  }, delay);
};

export const stopTokenRefreshTimer = () => {
  clearInterval(handleRefreshInterval);
};
